import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, switchMap, tap } from 'rxjs';
import { Profile } from 'src/app/settings/models/profile.model';
import { ExternalAccountResult } from 'src/app/shared/models/agency-mgmt/manager.service.model';
import { environment } from 'src/environments/environment';
import { BaseService } from '../base/base.service';
import { NotificationService } from '../../firebase/notification.service';

@Injectable({
  providedIn: 'root',
})
export class ManagerService extends BaseService {
  private readonly urlPrefix = `${environment.agencyMgmt.urlPrefix}/manager`;

  constructor(
    http: HttpClient,
    private notificationService: NotificationService
  ) {
    super(http);
  }

  public getExternalAccounts() {
    return this.get<ExternalAccountResult[]>(
      `${this.urlPrefix}/external-accounts`
    );
  }

  public getManagerCountry() {
    return this.get<any>(`${this.urlPrefix}/country-id`).pipe(
      map((res) => res.countryId)
    );
  }

  public getUserList() {
    return this.get<any>(`${this.urlPrefix}/list`);
  }

  public getProfile() {
    return this.get<any>(`${this.urlPrefix}/profile`);
  }

  public editProfile(profile: Profile) {
    return this.patch<Profile>(`${this.urlPrefix}/profile`, profile);
  }

  public getUnreadEmailCount() {
    return this.get<number>(`${this.urlPrefix}/unread-email-count`);
  }

  public UpdateUnreadEmailCount(isRead: boolean, userId: string) {
    let model = { isRead: isRead, userId: userId };
    return this.patch<any>(
      `${this.urlPrefix}/update-unread-email-count`,
      model
    ).pipe(
      switchMap((res) =>
        this.getUnreadEmailCount().pipe(
          tap((count) => this.notificationService.setEmailCount(count)),
          map(() => res)
        )
      )
    );
  }
}
